import { Component } from "react";
import { Outlet } from "react-router-dom";

import Headers from "../common/headers";
import Footers from "../common/footers";

class MainLayout extends Component {
  render() {
    return (
      <>
        <Headers />
        <Outlet />
        <Footers />
      </>
    );
  }
}

export default MainLayout;
